import { cloneDeep, isEqual } from 'lodash';
import { Contact, ContactInput, ManageContactInput } from 'sr-types/lib/production/v1/graphql';
import { Person } from 'sr-types/lib/search/v1/graphql';
import { compareRecentDate } from '../../common/utils/dateTime';
import { getFullName } from '../../person/person';

export function getKeyPeopleInput(
    peopleList: ContactWithKey[],
    markedPerson?: ContactWithKey,
    unmarkedPerson?: ContactWithKey,
    markNewPerson?: ContactWithKey
): ContactInput[] {
    const people = cloneDeep(peopleList);
    if (markedPerson) {
        people[peopleList.findIndex((person) => isEqual(person, markedPerson))].isKey = true;
    } else if (unmarkedPerson) {
        people[peopleList.findIndex((person) => isEqual(person, unmarkedPerson))].isKey = false;
    } else if (markNewPerson) {
        people.push(markNewPerson);
    }
    return people
        .filter((person) => person.isKey)
        .map((person) => {
            const { personReference, name, roles, productionRoles } = person;

            return {
                personReference: personReference,
                name: { firstName: name.firstName, lastName: name.lastName },
                roles,
                productionRoles
            };
        });
}

export type ContactWithKey = Contact & { isKey: boolean };

export function getPeopleWithKeyFlag(peopleList: Contact[], keyPeople: Contact[]): ContactWithKey[] {
    const people = peopleList
        ? peopleList.map((person) => {
              return {
                  ...person,
                  isKey:
                      Array.isArray(keyPeople) &&
                      keyPeople.some(
                          (contact) =>
                              contact?.personReference?.id === person?.personReference?.id &&
                              isEqual(getFullName(contact.name), getFullName(person.name)) &&
                              isEqual(contact?.roles, person?.roles) &&
                              isEqual(contact?.productionRoles, person?.productionRoles)
                      )
              };
          })
        : [];
    return people;
}

export { extractNames } from '../../person/utils/extractNames';

export function getMostRecentExperience(filteredExperiences) {
    if (!Array.isArray(filteredExperiences)) return null;

    const experiencesWithDates = filteredExperiences.filter((exp) => exp?.dateRange?.end || exp?.dateRange?.start);

    if (experiencesWithDates.length === 0) return null;

    experiencesWithDates.sort(compareRecentDate);

    return experiencesWithDates[0];
}

export function normalizePeople(people: Contact[]) {
    if (!Array.isArray(people)) return [];
    return people.map((person) => ({
        ...person, // keep all original properties
        id: person.personReference?.id ?? '',
        name: [person.name?.firstName, person.name?.lastName].filter(Boolean).join(' ').trim()
    }));
}

export function normalizeForKeyCheck(input: ManageContactInput['new']) {
    return {
        ...input,
        personReference: {
            id: input.personReference?.id,
            label: input.personReference?.label || '',
            type: input.personReference?.type || 'Person'
        },
        name: {
            firstName: input.name?.firstName?.trim(),
            lastName: input.name?.lastName?.trim()
        },
        roles: input.role && input.role.trim() !== '' ? [input.role] : [],
        productionRoles: input.productionRole && input.productionRole.trim() !== '' ? [input.productionRole] : [],
        isKey: true
    };
}

export function personToOption(person: Person) {
    return {
        ...person.reference
    };
}
